// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 视频任务节点样式 */

.VideoTaskNode-wrapper {
  padding: 16px;
  min-width: 380px;
  max-width: 450px;
}

/* 头部信息 */
.VideoTaskNode-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.VideoTaskNode-charge {
  margin: 8px 0;
  padding: 6px 10px;
  border-radius: 6px;
  color: #92400e;
  background: #fffbeb;
  font-size: 12px;
  font-weight: 600;
}

.VideoTaskNode-task-id {
  font-size: 12px;
  color: #6b7280;
  font-family: monospace;
}

/* 状态标签 */
.VideoTaskNode-status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.VideoTaskNode-status-pending {
  background-color: #fef3c7;
  color: #92400e;
}

.VideoTaskNode-status-processing {
  background-color: #dbeafe;
  color: #1e40af;
}

.VideoTaskNode-status-completed {
  background-color: #d1fae5;
  color: #065f46;
}

.VideoTaskNode-status-failed {
  background-color: #fee2e2;
  color: #991b1b;
}

/* 转存提示 */
.VideoTaskNode-transfer-hint {
  padding: 10px 12px;
  background-color: #e0e7ff;
  border: 1px solid #818cf8;
  border-radius: 8px;
  color: #3730a3;
  font-size: 12px;
  margin-bottom: 12px;
  text-align: center;
}

/* 参数展示 */
.VideoTaskNode-params {
  margin-bottom: 16px;
  padding: 12px;
  background-color: #f9fafb;
  border-radius: 8px;
}

.VideoTaskNode-params-title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 10px;
}

.VideoTaskNode-params-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 10px;
  margin-bottom: 10px;
}

.VideoTaskNode-param-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.VideoTaskNode-param-label {
  font-size: 11px;
  color: #6b7280;
  font-weight: 500;
}

.VideoTaskNode-param-value {
  font-size: 13px;
  color: #1f2937;
  font-weight: 500;
}

.VideoTaskNode-prompt {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e5e7eb;
}

.VideoTaskNode-prompt-label {
  font-size: 11px;
  color: #6b7280;
  font-weight: 500;
  margin-bottom: 6px;
}

.VideoTaskNode-prompt-text {
  font-size: 13px;
  line-height: 1.5;
  color: #374151;
  word-break: break-word;
}

/* 加载状态 */
.VideoTaskNode-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background-color: #f9fafb;
  border-radius: 8px;
  margin-bottom: 16px;
}

.VideoTaskNode-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e5e7eb;
  border-top-color: #8b5cf6;
  border-radius: 50%;
  animation: VideoTaskNode-spin 0.8s linear infinite;
  margin-bottom: 16px;
}

@keyframes VideoTaskNode-spin {
  to { transform: rotate(360deg); }
}

.VideoTaskNode-loading-text {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
  margin-bottom: 8px;
}

.VideoTaskNode-loading-hint {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 16px;
}

.VideoTaskNode-refresh-button {
  padding: 8px 16px;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
}

.VideoTaskNode-refresh-button:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}

/* 结果展示 */
.VideoTaskNode-results {
  margin-bottom: 16px;
}

.VideoTaskNode-results-title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
}

.VideoTaskNode-video-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.VideoTaskNode-video {
  width: 100%;
  border-radius: 8px;
  background-color: #000;
  max-height: 400px;
  object-fit: contain;
}

.VideoTaskNode-video-info {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  padding: 8px 12px;
  background-color: #f3f4f6;
  border-radius: 6px;
}

.VideoTaskNode-video-info-item {
  font-size: 12px;
  color: #4b5563;
  font-weight: 500;
}

.VideoTaskNode-download-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  background-color: #8b5cf6;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.VideoTaskNode-download-link:hover {
  background-color: #7c3aed;
  box-shadow: 0 2px 8px rgba(139, 92, 246, 0.3);
}

/* 失败状态 */
.VideoTaskNode-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  margin-bottom: 16px;
}

.VideoTaskNode-error-icon {
  font-size: 32px;
  margin-bottom: 12px;
}

.VideoTaskNode-error-text {
  font-size: 13px;
  color: #991b1b;
  text-align: center;
  line-height: 1.5;
  margin-bottom: 16px;
}

.VideoTaskNode-retry-button {
  padding: 8px 16px;
  background-color: white;
  border: 1px solid #fca5a5;
  border-radius: 6px;
  font-size: 13px;
  color: #dc2626;
  cursor: pointer;
  transition: all 0.2s ease;
}

.VideoTaskNode-retry-button:hover {
  background-color: #fef2f2;
  border-color: #f87171;
}

/* 耗时信息 */
.VideoTaskNode-metrics {
  padding: 12px;
  background-color: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
}

.VideoTaskNode-metrics-title {
  font-size: 13px;
  font-weight: 600;
  color: #166534;
  margin-bottom: 10px;
}

.VideoTaskNode-metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 10px;
}

.VideoTaskNode-metric-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.VideoTaskNode-metric-label {
  font-size: 11px;
  color: #15803d;
  font-weight: 500;
}

.VideoTaskNode-metric-value {
  font-size: 13px;
  color: #166534;
  font-weight: 600;
}

/* 帧提取工具栏 */
.VideoTaskNode-frame-extract {
  padding: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 6px;
  margin: 12px 0;
}

/* 帧提取禁用状态（视频未转存） */
.VideoTaskNode-frame-extract-disabled {
  padding: 8px;
  background-color: #f3f4f6;
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  margin: 12px 0;
}

.VideoTaskNode-frame-extract-disabled .VideoTaskNode-frame-extract-hint {
  color: #6b7280;
  font-size: 12px;
  text-align: center;
  background-color: transparent;
  animation: none;
}

.VideoTaskNode-frame-extract-title {
  font-size: 11px;
  font-weight: 600;
  color: white;
  margin-bottom: 6px;
  text-align: center;
}

.VideoTaskNode-frame-extract-buttons {
  display: flex;
  gap: 4px;
}

.VideoTaskNode-frame-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 8px;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #4c1d95;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  white-space: nowrap;
}

.VideoTaskNode-frame-button:hover:not(:disabled) {
  background-color: white;
  border-color: #8b5cf6;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(139, 92, 246, 0.3);
}

.VideoTaskNode-frame-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.VideoTaskNode-frame-button-active {
  background-color: #8b5cf6;
  color: white;
  border-color: #7c3aed;
}

.VideoTaskNode-frame-button-loading {
  font-size: 14px;
  animation: VideoTaskNode-frame-pulse 1s ease-in-out infinite;
}

@keyframes VideoTaskNode-frame-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.VideoTaskNode-frame-extract-hint {
  margin-top: 6px;
  padding: 4px 6px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: white;
  font-size: 10px;
  text-align: center;
  animation: VideoTaskNode-frame-pulse 1s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/VideoTaskNode.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,4DAA4D;AAC9D","sourcesContent":["/* 视频任务节点样式 */\n\n.VideoTaskNode-wrapper {\n  padding: 16px;\n  min-width: 380px;\n  max-width: 450px;\n}\n\n/* 头部信息 */\n.VideoTaskNode-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.VideoTaskNode-charge {\n  margin: 8px 0;\n  padding: 6px 10px;\n  border-radius: 6px;\n  color: #92400e;\n  background: #fffbeb;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.VideoTaskNode-task-id {\n  font-size: 12px;\n  color: #6b7280;\n  font-family: monospace;\n}\n\n/* 状态标签 */\n.VideoTaskNode-status-badge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.VideoTaskNode-status-pending {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.VideoTaskNode-status-processing {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n\n.VideoTaskNode-status-completed {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.VideoTaskNode-status-failed {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n/* 转存提示 */\n.VideoTaskNode-transfer-hint {\n  padding: 10px 12px;\n  background-color: #e0e7ff;\n  border: 1px solid #818cf8;\n  border-radius: 8px;\n  color: #3730a3;\n  font-size: 12px;\n  margin-bottom: 12px;\n  text-align: center;\n}\n\n/* 参数展示 */\n.VideoTaskNode-params {\n  margin-bottom: 16px;\n  padding: 12px;\n  background-color: #f9fafb;\n  border-radius: 8px;\n}\n\n.VideoTaskNode-params-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 10px;\n}\n\n.VideoTaskNode-params-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.VideoTaskNode-param-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.VideoTaskNode-param-label {\n  font-size: 11px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.VideoTaskNode-param-value {\n  font-size: 13px;\n  color: #1f2937;\n  font-weight: 500;\n}\n\n.VideoTaskNode-prompt {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.VideoTaskNode-prompt-label {\n  font-size: 11px;\n  color: #6b7280;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.VideoTaskNode-prompt-text {\n  font-size: 13px;\n  line-height: 1.5;\n  color: #374151;\n  word-break: break-word;\n}\n\n/* 加载状态 */\n.VideoTaskNode-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.VideoTaskNode-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e5e7eb;\n  border-top-color: #8b5cf6;\n  border-radius: 50%;\n  animation: VideoTaskNode-spin 0.8s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes VideoTaskNode-spin {\n  to { transform: rotate(360deg); }\n}\n\n.VideoTaskNode-loading-text {\n  font-size: 14px;\n  color: #374151;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.VideoTaskNode-loading-hint {\n  font-size: 12px;\n  color: #6b7280;\n  margin-bottom: 16px;\n}\n\n.VideoTaskNode-refresh-button {\n  padding: 8px 16px;\n  background-color: white;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.VideoTaskNode-refresh-button:hover {\n  background-color: #f9fafb;\n  border-color: #9ca3af;\n}\n\n/* 结果展示 */\n.VideoTaskNode-results {\n  margin-bottom: 16px;\n}\n\n.VideoTaskNode-results-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 12px;\n}\n\n.VideoTaskNode-video-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.VideoTaskNode-video {\n  width: 100%;\n  border-radius: 8px;\n  background-color: #000;\n  max-height: 400px;\n  object-fit: contain;\n}\n\n.VideoTaskNode-video-info {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 8px 12px;\n  background-color: #f3f4f6;\n  border-radius: 6px;\n}\n\n.VideoTaskNode-video-info-item {\n  font-size: 12px;\n  color: #4b5563;\n  font-weight: 500;\n}\n\n.VideoTaskNode-download-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 16px;\n  background-color: #8b5cf6;\n  color: white;\n  text-decoration: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.VideoTaskNode-download-link:hover {\n  background-color: #7c3aed;\n  box-shadow: 0 2px 8px rgba(139, 92, 246, 0.3);\n}\n\n/* 失败状态 */\n.VideoTaskNode-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.VideoTaskNode-error-icon {\n  font-size: 32px;\n  margin-bottom: 12px;\n}\n\n.VideoTaskNode-error-text {\n  font-size: 13px;\n  color: #991b1b;\n  text-align: center;\n  line-height: 1.5;\n  margin-bottom: 16px;\n}\n\n.VideoTaskNode-retry-button {\n  padding: 8px 16px;\n  background-color: white;\n  border: 1px solid #fca5a5;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #dc2626;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.VideoTaskNode-retry-button:hover {\n  background-color: #fef2f2;\n  border-color: #f87171;\n}\n\n/* 耗时信息 */\n.VideoTaskNode-metrics {\n  padding: 12px;\n  background-color: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 8px;\n}\n\n.VideoTaskNode-metrics-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #166534;\n  margin-bottom: 10px;\n}\n\n.VideoTaskNode-metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 10px;\n}\n\n.VideoTaskNode-metric-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.VideoTaskNode-metric-label {\n  font-size: 11px;\n  color: #15803d;\n  font-weight: 500;\n}\n\n.VideoTaskNode-metric-value {\n  font-size: 13px;\n  color: #166534;\n  font-weight: 600;\n}\n\n/* 帧提取工具栏 */\n.VideoTaskNode-frame-extract {\n  padding: 8px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 6px;\n  margin: 12px 0;\n}\n\n/* 帧提取禁用状态（视频未转存） */\n.VideoTaskNode-frame-extract-disabled {\n  padding: 8px;\n  background-color: #f3f4f6;\n  border: 1px dashed #d1d5db;\n  border-radius: 6px;\n  margin: 12px 0;\n}\n\n.VideoTaskNode-frame-extract-disabled .VideoTaskNode-frame-extract-hint {\n  color: #6b7280;\n  font-size: 12px;\n  text-align: center;\n  background-color: transparent;\n  animation: none;\n}\n\n.VideoTaskNode-frame-extract-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 6px;\n  text-align: center;\n}\n\n.VideoTaskNode-frame-extract-buttons {\n  display: flex;\n  gap: 4px;\n}\n\n.VideoTaskNode-frame-button {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 6px 8px;\n  background-color: rgba(255, 255, 255, 0.9);\n  border: 1px solid transparent;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #4c1d95;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex: 1;\n  white-space: nowrap;\n}\n\n.VideoTaskNode-frame-button:hover:not(:disabled) {\n  background-color: white;\n  border-color: #8b5cf6;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(139, 92, 246, 0.3);\n}\n\n.VideoTaskNode-frame-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.VideoTaskNode-frame-button-active {\n  background-color: #8b5cf6;\n  color: white;\n  border-color: #7c3aed;\n}\n\n.VideoTaskNode-frame-button-loading {\n  font-size: 14px;\n  animation: VideoTaskNode-frame-pulse 1s ease-in-out infinite;\n}\n\n@keyframes VideoTaskNode-frame-pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.VideoTaskNode-frame-extract-hint {\n  margin-top: 6px;\n  padding: 4px 6px;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  color: white;\n  font-size: 10px;\n  text-align: center;\n  animation: VideoTaskNode-frame-pulse 1s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
